import _slicedToArray from "/builds/mfresearchtool/mfresearchtool-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _classCallCheck from "/builds/mfresearchtool/mfresearchtool-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/builds/mfresearchtool/mfresearchtool-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/builds/mfresearchtool/mfresearchtool-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/builds/mfresearchtool/mfresearchtool-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/builds/mfresearchtool/mfresearchtool-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
import { me as a } from "./abstract-base-8edf0a84-e11d45a3.js";
import { T as h, _ as l, s as d } from "./directive-daf4e9b6-abc0af54.js";
/**
 * @license
 * Copyright 2018 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
var f = h( /*#__PURE__*/function (_l) {
  _inherits(_class, _l);
  function _class(s) {
    var _this;
    _classCallCheck(this, _class);
    var e;
    if (_this = _possibleConstructorReturn(this, _getPrototypeOf(_class).call(this, s)), s.type !== d.ATTRIBUTE || s.name !== "class" || ((e = s.strings) == null ? void 0 : e.length) > 2) throw Error("`classMap()` can only be used in the `class` attribute and must be the only part in the attribute.");
    return _possibleConstructorReturn(_this);
  }
  _createClass(_class, [{
    key: "render",
    value: function render(s) {
      return " " + Object.keys(s).filter(function (e) {
        return s[e];
      }).join(" ") + " ";
    }
  }, {
    key: "update",
    value: function update(s, _ref) {
      var _ref2 = _slicedToArray(_ref, 1),
        e = _ref2[0];
      var r, i;
      if (this.st === void 0) {
        this.st = /* @__PURE__ */new Set(), s.strings !== void 0 && (this.nt = new Set(s.strings.join(" ").split(/\s/).filter(function (t) {
          return t !== "";
        })));
        for (var t in e) e[t] && !((r = this.nt) != null && r.has(t)) && this.st.add(t);
        return this.render(e);
      }
      var n = s.element.classList;
      var _iterator = _createForOfIteratorHelper(this.st),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var _t2 = _step.value;
          _t2 in e || (n.remove(_t2), this.st.delete(_t2));
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      for (var _t in e) {
        var o = !!e[_t];
        o === this.st.has(_t) || (i = this.nt) != null && i.has(_t) || (o ? (n.add(_t), this.st.add(_t)) : (n.remove(_t), this.st.delete(_t)));
      }
      return a;
    }
  }]);
  return _class;
}(l));
export { f as u };